/** @module csi/datasheet/CanvasImageController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/_ImageBrowseMixin",
	"csi/action/Controller",
	"csi/image/_base",
	"csi/reflection"
], function(declare,_,_ImageBrowseMixin,Controller,csiImage,reflection) {

	return declare([Controller,_ImageBrowseMixin], {
		// Boolean: indicates whether action is filling a placeholder (vs inserting an image onto canvas)
		placeholder: false,
	
		/**
		 * Make sure image toggle button is untoggled
		 */
		onBrowserCancel: function() {
			this.widget.canvasWidgetNode.updateToolbar();
		},
		
		/**
		 * Add selected images to canvas
		 * @param {Node[]} nodes
		 */
		onBrowserSave: function(nodes) {
			var images = nodes.map(function(node) {
				return {
					alt: node.$Name,
					src: csiImage.getImageSrc(node, null, reflection.ATTR_VIEWABLE)
				};
			});

			if (this.placeholder) {
				if (this.placeholder.length) {
					_.each(this.placeholder, (p) => {
						this.widget.canvasWidgetNode.insertImageAtPlaceholder(images[0], p);
					});
				} else {
					this.widget.canvasWidgetNode.insertImageAtPlaceholder(images[0], this.placeholder);
				}
			} else {
				this.widget.canvasWidgetNode.addImages(images, 0, 0);
			}
		},

		/**
		 * Return canvas owner
		 * @return {Node}
		 */
		_getImageContext: function() {
			return this.widget.canvasOwner;
		}
	});
});